import { colors, Tabs } from '@sweep-io/sweep-design';
import { useState } from 'react';
import {
  ConfigurationCanvasLeftPanel,
  ConfigurationCanvasPanelContent,
  ConfigurationCanvasPanelHeader,
} from '../configuration-canvas-panel';
import { MultipleRuleBuildersProvider } from '../../common/sweep-condition-rule-builder/MultipleRuleBuildersContext';
import { Stack, Box } from '@mui/material';
import { useGetSidePadding } from '../configuration-canvas-panel/useGetSidePadding';
import Automations from '../../Automations/Automations';
import ScheduledJobs from '../../Automations/ScheduledJobs';
import { GlobalRenderer } from '../global-renderer/GlobalRenderer';

enum AutomationsDialogTabTypes {
  AUTOMATIONS = 'Automations',
  SCHEDULED_JOBS = 'Scheduled jobs',
}

export const AutomationPage = () => {
  const [activeTab, setActiveTab] = useState(AutomationsDialogTabTypes.AUTOMATIONS);
  const sidePadding = useGetSidePadding();

  return (
    <GlobalRenderer>
      <ConfigurationCanvasLeftPanel withExpandedModeButton={true} sx={{ gap: 3 }}>
        <ConfigurationCanvasPanelHeader withExpandedModeButton={true}>
          Automations
        </ConfigurationCanvasPanelHeader>
        <MultipleRuleBuildersProvider>
          <ConfigurationCanvasPanelContent
            sx={{
              overflow: 'hidden',
              height: '100%',
              padding: 0,
              display: 'flex',
            }}
          >
            <Stack
              sx={{
                flex: 1,
                overflow: 'hidden',
                gap: 3,
                '& .MuiTabs-root': {
                  display: 'flex',
                },
                '.MuiTabs-root': {
                  borderBottom: `1px solid ${colors.grey[120]}`,
                },
              }}
            >
              <Box
                sx={{
                  padding: `0 ${sidePadding}px`,
                }}
              >
                <Tabs
                  value={activeTab}
                  tabs={[
                    {
                      label: AutomationsDialogTabTypes.AUTOMATIONS,
                      value: AutomationsDialogTabTypes.AUTOMATIONS,
                    },
                    {
                      label: AutomationsDialogTabTypes.SCHEDULED_JOBS,
                      value: AutomationsDialogTabTypes.SCHEDULED_JOBS,
                    },
                  ]}
                  onChange={(event, tab) => {
                    setActiveTab(tab as AutomationsDialogTabTypes);
                  }}
                />
              </Box>
              {activeTab === AutomationsDialogTabTypes.AUTOMATIONS && <Automations />}
              {activeTab === AutomationsDialogTabTypes.SCHEDULED_JOBS && <ScheduledJobs />}
            </Stack>
          </ConfigurationCanvasPanelContent>
        </MultipleRuleBuildersProvider>
      </ConfigurationCanvasLeftPanel>
    </GlobalRenderer>
  );
};
